import { useEffect } from 'react';

import { socket } from '@/socket';
import { logg } from '@/util/logg';
import {
	resumeGame,
	startGame,
	startSinglePlayerGame,
	updateGameState,
	updatePlayers,
} from '@lc/const/socketEvent';

export function useSocketListeners({
	setPlayers,
	setInitState,
	// setGameState,
	setStateChangeHistory,
	setStartGameBool,
	setSinglePlayer,
	setCurrPlayer,
	enabled,
}) {
	useEffect(() => {
		logg('attempting socket connection here');
		if (!enabled) {
			// socket.disconnect();
			return;
		}

		if (!socket) {
			logg('SOCKET AINT SOCKETING');
			return;
		}

		if (!socket.connected) {
			socket.connect();
		}

		socket.on(startGame, ({ initState, stateChangeHistory }) => {
			logg('*** startGame ***');
			logg(initState);
			logg(stateChangeHistory);
			// set my state for player that matches my user_id or lobby_id...
			setInitState(initState);
			setStateChangeHistory(stateChangeHistory);
			setStartGameBool(true);
		});

		socket.on(
			startSinglePlayerGame,
			({ initState, stateChangeHistory }) => {
				setInitState(initState);
				setStateChangeHistory(stateChangeHistory);
				setSinglePlayer(true);
				setStartGameBool(true);
			}
		);

		socket.on(resumeGame, ({ initState, stateChangeHistory }) => {
			setSinglePlayer(initState.singlePlayer);
			setInitState(initState);
			// setGameState(gameState);
			setStateChangeHistory(stateChangeHistory);
		});

		socket.on(updateGameState, ({ stateChangeHistory }) => {
			setStateChangeHistory(stateChangeHistory);
		});

		socket.on(updatePlayers, setPlayers);

		const onPlayersSnapshot = (players: any) => {
			logg('PLAYER SNAPSHOT HERE');
			setPlayers(players);
		};

		const onPlayerJoined = (player: any) => {
			logg('PLAYER JOINED HERE');
			setPlayers((prev) => [...prev, player]);
		};

		const onPlayerLeft = (socketId: string) => {
			logg('PLAYER LEFT HERE');
			setPlayers((prev) => prev.filter((p) => p.socketId !== socketId));
		};

		socket.on('room:players', onPlayersSnapshot);
		socket.on('room:playerJoined', onPlayerJoined);
		socket.on('room:playerLeft', onPlayerLeft);

		socket.on('assignCurrPlayer', (currPlayer) => {
			logg('assignCurrPlayer');
			logg(currPlayer);
			setCurrPlayer(currPlayer);
		});

		socket.on('message', () => {
			logg(`*** Player has joined the game. ***`);
		});

		return () => {
			socket.off(startGame);
			socket.off(startSinglePlayerGame);
			socket.off(resumeGame);
			socket.off(updateGameState);
			socket.off(updatePlayers);

			socket.off('room:players', onPlayersSnapshot);
			socket.off('room:playerJoined', onPlayerJoined);
			socket.off('room:playerLeft', onPlayerLeft);
			socket.off('assignCurrPlayer');
		};
	}, [enabled]); // enabled
}
